var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1645154550266,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1741,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 512C1024 229.216 794.784 0 512 0S0 229.216 0 512c0 220.064 138.848 407.648 333.696 480.064L320 1024l384 0-13.696-31.936C885.152 919.648 1024 732.064 1024 512zM486.784 634.816C463.968 625.024 448 602.4 448 576c0-35.36 28.64-64 64-64 35.36 0 64 28.64 64 64 0 26.4-15.968 49.056-38.784 58.848L512 576 486.784 634.816zM538.272 637.28C596.352 625.184 640 573.696 640 512c0-70.688-57.312-128-128-128-70.688 0-128 57.312-128 128 0 61.696 43.648 113.12 101.76 125.216l-74.624 174.112C319.904 772.192 256 681.568 256 576c0-141.376 114.624-268 256-268s256 126.624 256 268c0 105.568-63.904 196.192-155.136 235.36L538.272 637.28zM688.448 987.712l-73.92-172.48C740.96 772.48 832 652.864 832 512c0-176.736-143.264-320-320-320-176.736 0-320 143.264-320 320 0 140.864 91.04 260.48 217.472 303.232l-73.92 172.48C175.968 919.232 64.16 760.672 64.16 576 64.16 328.672 264.672 116.16 512 116.16c247.328 0 447.84 212.512 447.84 459.84C959.84 760.672 848.032 919.232 688.448 987.712z",
    "p-id": 1742
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.a07314dc.svg";
export { ForwardRef as ReactComponent };